// Lib
import React from 'react';

// Components
import DefaultErrorRenderer from '../../error/errorBoundary/DefaultErrorRenderer';
import { useTranslator } from '../../i18n/useTranslator';

// Styles
import './ModalErrorRenderer.scss';

const ModalErrorRenderer = (props) => {
    const translate = useTranslator('modal', 'error.modalBoundary');
    return (
        <DefaultErrorRenderer
            {...props}
            className="ModalErrorRenderer"
            heading={translate('heading')}
        />
    );
};

export default ModalErrorRenderer;
